module.exports = __webpack_public_path__ + "static/media/66_tn.6f1d2543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/66_tn.jpg
// module id = 553
// module chunks = 0